import { useState } from 'react';
import { useCartStore } from '../store/cartStore.js';
import { IcoClose } from './common/Icons.jsx';
import styles from './ItemEditSheet.module.css';

const QUICK_DISCOUNTS = [
  { label: '10%', pct: 10 },
  { label: '15%', pct: 15 },
  { label: '20%', pct: 20 },
  { label: '25%', pct: 25 },
  { label: 'Gratis', pct: 100 },
];

const fmt = (n) => `$${Number(n).toLocaleString('es-MX', { minimumFractionDigits: 2 })}`;

export default function ItemEditSheet({ item, onClose }) {
  const updateQuantity = useCartStore((s) => s.updateQuantity);
  const setItemPrice   = useCartStore((s) => s.setItemPrice);
  const removeItem     = useCartStore((s) => s.removeItem);

  const originalPrice = item.product.price;

  const [qty,   setQty]   = useState(String(item.quantity));
  const [price, setPrice] = useState(String(item.unit_price));

  const qtyNum   = Math.max(1, Number(qty)   || 1);
  const priceNum = Math.max(0, Number(price) || 0);

  const discountPct = originalPrice > 0
    ? Math.round(((originalPrice - priceNum) / originalPrice) * 100)
    : 0;

  const applyQuickDiscount = (pct) => {
    const newPrice = pct === 100 ? 0 : +(originalPrice * (1 - pct / 100)).toFixed(2);
    setPrice(String(newPrice));
  };

  const handleConfirm = () => {
    if (qtyNum !== item.quantity)       updateQuantity(item.product._id, qtyNum);
    if (priceNum !== item.unit_price)   setItemPrice(item.product._id, priceNum);
    onClose();
  };

  const handleRemove = () => {
    removeItem(item.product._id);
    onClose();
  };

  return (
    <div className={styles.overlay} onClick={(e) => e.target === e.currentTarget && onClose()}>
      <div className={styles.sheet}>
        <div className={styles.handle} />

        <div className={styles.header}>
          <div className={styles.itemName}>{item.product.name}</div>
          <div className={styles.itemOriginal}>Precio lista: {fmt(originalPrice)}</div>
        </div>

        {/* Cantidad */}
        <div className={styles.field}>
          <label className={styles.label}>Cantidad</label>
          <div className={styles.qtyRow}>
            <button className={styles.qtyBtn} onClick={() => setQty(String(Math.max(1, qtyNum - 1)))}>−</button>
            <input
              className={`input ${styles.qtyInput}`}
              type="number"
              min="1"
              value={qty}
              onChange={(e) => setQty(e.target.value)}
              inputMode="numeric"
            />
            <button className={styles.qtyBtn} onClick={() => setQty(String(qtyNum + 1))}>+</button>
          </div>
        </div>

        {/* Precio unitario */}
        <div className={styles.field}>
          <div className={styles.priceLabelRow}>
            <label className={styles.label}>Precio unitario</label>
            {discountPct > 0 && (
              <span className={styles.discountBadge}>−{discountPct}%</span>
            )}
          </div>
          <div className={styles.currencyRow}>
            <span className={styles.currencySymbol}>$</span>
            <input
              className={`input ${styles.priceInput}`}
              type="number"
              min="0"
              step="0.01"
              value={price}
              onChange={(e) => setPrice(e.target.value)}
              inputMode="decimal"
              style={{ paddingLeft: 32 }}
            />
          </div>
        </div>

        {/* Descuentos rápidos */}
        <div className={styles.quickRow}>
          {QUICK_DISCOUNTS.map((d) => (
            <button
              key={d.label}
              className={`${styles.quickBtn} ${discountPct === d.pct ? styles.quickBtnActive : ''}`}
              onClick={() => applyQuickDiscount(d.pct)}
            >
              {d.label}
            </button>
          ))}
          {discountPct > 0 && (
            <button className={styles.quickBtn} onClick={() => setPrice(String(originalPrice))}>
              <IcoClose size={12} /> Reset
            </button>
          )}
        </div>

        {/* Línea de total */}
        <div className={styles.totalLine}>
          <span>Subtotal de este ítem</span>
          <strong>{fmt(qtyNum * priceNum)}</strong>
        </div>

        <div className={styles.actions}>
          <button className="btn btn--danger" onClick={handleRemove}>
            Quitar
          </button>
          <button className="btn btn--primary" style={{ flex: 1 }} onClick={handleConfirm}>
            Aplicar
          </button>
        </div>
      </div>
    </div>
  );
}
